<mat-form-field class="w-all">
  <mat-label>{{ label }}</mat-label>
  <input matInput [matDatepicker]="dp" [formControl]="date" [min]="minDate" [max]="maxDate" (focus)="markAsTouched()" />
  <mat-hint>MM/YYYY</mat-hint>
  <mat-datepicker-toggle matSuffix [for]="dp">
    <mat-icon class="calendar" matDatepickerToggleIcon> <img src="/assets/svg/calendar.svg" /> </mat-icon>
  </mat-datepicker-toggle>
  <mat-datepicker #dp startView="multi-year" (monthSelected)="setMonthAndYear($event, dp)"> </mat-datepicker>
</mat-form-field>
